import Vue from 'vue'
import Router from 'vue-router'
import Dash from '@/components/Dash.vue'
// import Hello from '@/components/HelloWorld.vue'
import LoginView from '@/components/pages/Login.vue'
import UserSearchView from '@/components/pages/Usuarios/Search.vue'
import UserCadastroView from '@/components/pages/Usuarios/Cadastro.vue'
import UserDetailView from '@/components/pages/Usuarios/Detail.vue'
import ProjetosSearchView from '@/components/pages/Projetos/Search.vue'
import ProjetoDetailView from '@/components/pages/Projetos/Detail.vue'
import Avaliacao from '@/components/pages/Projetos/Avaliacao.vue'
import ProjetoCadastroView from '@/components/pages/Projetos/Cadastro.vue'
import ProgramaCadastroView from '@/components/pages/Programa/Cadastro.vue'
import ProgramaDetailView from '@/components/pages/Programa/Detail.vue'
import ProgramasSearchView from '@/components/pages/Programa/Search.vue'
import TurmasSearchView from '@/components/pages/Turmas/Search.vue'
import TurmaDetailView from '@/components/pages/Turmas/Detail.vue'
import TurmaCadastroView from '@/components/pages/Turmas/Cadastro.vue'
import UnidadesSearchView from '@/components/pages/Unidades/Search.vue'
import UnidadeDetailView from '@/components/pages/Unidades/Detail.vue'
import UnidadeCadastroView from '@/components/pages/Unidades/Cadastro.vue'
import Calendario from '@/components/pages/Calendario/Calendario.vue'
import PadroesSearchView from '@/components/pages/Padroes/Search.vue'
import PadraoDetailView from '@/components/pages/Padroes/Detail.vue'
import PadraoCadastroView from '@/components/pages/Padroes/Cadastro.vue'
import Home from '@/components/pages/Home.vue'
import EmpresaSearchView from '@/components/pages/Empresas/Search.vue'
import EmpresaDetailView from '@/components/pages/Empresas/Detail.vue'
import EmpresaCadastroView from '@/components/pages/Empresas/Cadastro.vue'
import AlertCentral from '@/components/pages/AlertCentral.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dash',
      component: Dash,
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          component: Home,
          name: 'Home',
          meta: {
            auth: true
          }
        },
        {
          path: 'calendario/:tipo/:slug',
          component: Calendario,
          name: 'Calendário',
          auth: true,
          meta: {description: '', auth: true}
        },
        {
          path: 'usuarios/busca',
          component: UserSearchView,
          name: 'usuarios-busca',
          meta: {
            auth: true
          }
        },
        {
          path: 'usuarios/cadastro',
          component: UserCadastroView,
          name: 'usuarios-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'usuarios/:username',
          component: UserDetailView,
          name: 'usuarios-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'central',
          component: AlertCentral,
          name: 'central',
          meta: {
            auth: true
          }
        },
        {
          path: 'projetos',
          component: ProjetosSearchView,
          name: 'projetos',
          meta: {
            auth: true
          }
        },
        {
          path: 'projetos/:id',
          component: ProjetoDetailView,
          name: 'projeto-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'projetos/:id/avaliacao',
          component: Avaliacao,
          name: 'avaliacao',
          meta: {
            auth: true
          }
        },
        {
          path: 'projetos/new',
          component: ProjetoCadastroView,
          name: 'projeto-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'padroes',
          component: PadroesSearchView,
          name: 'padroes',
          meta: {
            auth: true
          }
        },
        {
          path: 'padroes/:id',
          component: PadraoDetailView,
          name: 'padrao-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'padroes/new',
          component: PadraoCadastroView,
          name: 'padrao-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'programa/new',
          component: ProgramaCadastroView,
          name: 'programa-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'programas/:slug',
          component: ProgramaDetailView,
          name: 'programa-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'programas',
          component: ProgramasSearchView,
          name: 'programas',
          meta: {
            auth: true
          }
        },
        {
          path: 'unidade/new',
          component: UnidadeCadastroView,
          name: 'unidade-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'unidades/:slug',
          component: UnidadeDetailView,
          name: 'unidade-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'unidades',
          component: UnidadesSearchView,
          name: 'unidades',
          meta: {
            auth: true
          }
        },
        {
          path: 'turmas',
          component: TurmasSearchView,
          name: 'turmas',
          meta: {
            auth: true
          }
        },
        {
          path: 'turmas/:slug',
          component: TurmaDetailView,
          name: 'turma-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'turmas/new',
          component: TurmaCadastroView,
          name: 'turma-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'empresas/new',
          component: EmpresaCadastroView,
          name: 'empresa-cadastro',
          meta: {
            auth: true
          }
        },
        {
          path: 'empresas/:id',
          component: EmpresaDetailView,
          name: 'empresa-detail',
          meta: {
            auth: true
          }
        },
        {
          path: 'empresas',
          component: EmpresaSearchView,
          name: 'empresas',
          meta: {
            auth: true
          }
        }
      ]
    },
    {
      path: '/login',
      component: LoginView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js